import Route from '@ember/routing/route';

export default class UnenrolRoute extends Route {
  setupController(controller) {
    super.setupController(...arguments);
    controller.reset();
  }

  resetController(controller) {
    super.resetController(...arguments);
    controller.reset();
  }
}
